module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "firstcenter"
  }), _vm._v(" "), _c('p', {
    staticClass: "firstcenter"
  }, [_vm._v("For Breck"), _c('br'), _vm._v("\n  Romans 15:5-6")]), _vm._v(" "), _c('p', {
    staticClass: "firstcenter",
    attrs: {
      "xmlns:xml": "http://www.w3.org/XML/1998/namespace"
    }
  }, [_c('img', {
    attrs: {
      "alt": "",
      "src": "Images/8429_DED.jpg"
    }
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7d071e90","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Text/dedication.vue
// module id = 63
// module chunks = 0